import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async getPaymentMethods(params) {
        return Axios.get(`${baseURL}payment/payment-method`, {
            params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async deletePaymentMethod(id) {
        return Axios.delete(`${baseURL}payment/payment-method/${id}`).then(
            response => response
        );
    },
    async createPaymentMethod(params) {
        return Axios.post(`${baseURL}payment/payment-method`, params).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    async makePrimaryPaymentMethod(params) {
        return Axios.post(
            `${baseURL}payment/assign-primary-payment-method`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async getSubscriptions(params) {
        return Axios.get(`${baseURL}account/subscription/list`, {
            params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async getPrimaryPaymentMethod() {
        return Axios.get(`${baseURL}payment/payment-method/primary`).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    async getSubscriptionInfo() {
        return Axios.get(
            `${baseURL}account/subscription/edit-subscription-info`
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async updateSubscription(params) {
        return Axios.post(
            `${baseURL}account/subscription/update-subscription`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async getInvoices(params) {
        return Axios.post(`${baseURL}api/zuora/account/invoices`, {
            ...params
        }).then(res => {
            if (res && res.data) {
                const result = Object.entries(res.data).map(([key, value]) => ({
                    index: parseInt(key, 10),
                    ...value
                }));
                return result;
            }
            return null;
        });
    },
    async getInvoicePdf(id) {
        return Axios.post(
            `${baseURL}api/zuora/invoice/pdf`,
            {
                invoice_id: id
            },
            { responseType: "arraybuffer" }
        ).then(res => {
            if (res && res.data) {
                return res.data;
            }
            return null;
        });
    }
};
